import { Action } from './core/action';

export class DistantSaleAction implements Action {
  constructor(public type: string, public paymentType?: string) {}
}



// WEBPACK FOOTER //
// src/app/common/actions/distant-sale-action.ts